import { render } from "./dealerTab.vue?vue&type=template&id=c025202c&scoped=true"
import script from "./dealerTab.vue?vue&type=script&lang=js"
export * from "./dealerTab.vue?vue&type=script&lang=js"

import "./dealerTab.vue?vue&type=style&index=0&id=c025202c&lang=scss&scoped=true"

import exportComponent from "/Users/jinjing/Desktop/jj/code1/HM0518/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c025202c"]])

export default __exports__